import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import './App.css';

// Components
import Header from './components/Header';
import Footer from './components/Footer';

// Pages
import Home from './pages/Home';
import ServiciosPage from './pages/ServiciosPage';
import LimpiezaPage from './pages/LimpiezaPage';
import AuxiliaresPage from './pages/AuxiliaresPage';
import MantenimientoPage from './pages/MantenimientoPage';
import RRHHPage from './pages/RRHHPage';
import SociosanitariosPage from './pages/SociosanitariosPage';
import SolucionesIntegralesPage from './pages/SolucionesIntegralesPage';
import NosotrosPage from './pages/NosotrosPage';
import ContactoPage from './pages/ContactoPage';
import AdminPage from './pages/AdminPage';

function AppContent() {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  const transparentHeaderRoutes = ['/', '/servicios', '/nosotros', '/contacto'];
  const isHeroPage = transparentHeaderRoutes.includes(location.pathname);
  const isAdminPage = location.pathname === '/admin';

  useEffect(() => {
    setScrolled(false);
    window.scrollTo(0, 0);
  }, [location.pathname]);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="App">
      {!isAdminPage && <Header scrolled={scrolled} isHome={isHeroPage} />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/servicios" element={<ServiciosPage />} />
        <Route path="/servicios/limpieza" element={<LimpiezaPage />} />
        <Route path="/servicios/auxiliares" element={<AuxiliaresPage />} />
        <Route path="/servicios/mantenimiento" element={<MantenimientoPage />} />
        <Route path="/servicios/rrhh" element={<RRHHPage />} />
        <Route path="/servicios/sociosanitarios" element={<SociosanitariosPage />} />
        <Route path="/servicios/soluciones-integrales" element={<SolucionesIntegralesPage />} />
        <Route path="/nosotros" element={<NosotrosPage />} />
        <Route path="/contacto" element={<ContactoPage />} />
        <Route path="/admin" element={<AdminPage />} />
      </Routes>
      {!isAdminPage && <Footer />}
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
